import { useTranslation } from "react-i18next";
import { LoadingOverlay } from "~/shared/ui/LoadingOverlay";

/**
 * 카메라 매핑 저장 진행 중 표시 (F5). 저장은 여러 API 를 순차 호출하는 다초 작업이라,
 * 토스트(완료 후)만으론 진행 상태를 알 수 없던 문제를 해결한다. 저장 동안 입력도 가볍게 막는다.
 *
 * 공용 LoadingOverlay 의 얇은 래퍼 — 문구/네임스페이스만 주입.
 */
export function SaveLoadingOverlay() {
  const { t } = useTranslation("camera-mapping");
  return <LoadingOverlay text={t("loading.saving")} />;
}
